import { React, useEffect, useState } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox, Radio } from "antd";
import warning from "../../../Assets/Icons/warning.png";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { ModalPopup } from "../../../Components/Modal/modal";
import { Collapse } from "antd";
import { getUnitData } from "../../../Services/measurementService";
import {
  weightUnit,
  weight_Unit_Conversions,
  orderDim_Rewinder_Unit_Conversion,
  conversionFactorUnitsToTonne,
  conversionFactorTonneToUnits,
  CoversionFactorUnitsToCM,
  lengthUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getPendingQtyDetails } from "../../../Services/orderServices";
import { toHandlePOName } from "../../../Utils/helper/helper";

const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;

const ViewPendingQuantityDrawer = (props) => {
  const [form] = Form.useForm();
  const [pendingQtyData, setPendingQtyData] = useState();

  useEffect(() => {
    (async () => {
      try {
        const data = await getPendingQtyDetails(props.selectedOrderNo);
        if (!data.error) {
          setPendingQtyData(data.data);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [props]);

  const handleClose = () => {
    form.resetFields();
    props.onCloseGrade();
  };

  return pendingQtyData ? (
    <RightDrawerSidebar
      title={`Pending Quantity Details`}
      subtitle=""
      visible={props.visible}
      onClose={handleClose}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "5px" }}
                // onFinish={onFinish}
                form={form}
              >
                <div
                  className="drawerField"
                  style={{ paddingTop: "0px", marginTop: "-9px" }}
                >
                  <div className="titleWithText">
                    <h5>Order Details</h5>
                    <p style={{ marginBottom: "0px" }}>
                      {pendingQtyData.category === "so" ? (
                        <p style={{ marginBottom: "0px" }}>
                          Stock Order : {toHandlePOName(pendingQtyData?.so)}
                        </p>
                      ) : (
                        <p style={{ marginBottom: "0px" }}>
                          Purchase Order : {toHandlePOName(pendingQtyData.po)}
                        </p>
                      )}
                    </p>{" "}
                    <p style={{ marginBottom: "0px" }}>
                      Order Number : {pendingQtyData.id}
                    </p>
                    <p style={{ marginBottom: "0px" }}>
                      Size : {""}
                      {pendingQtyData.type == "sheet"
                        ? pendingQtyData?.length +
                          " " +
                          lengthUnit[
                            pendingQtyData?.units?.length
                          ]?.displayName?.toUpperCase() +
                          " x " +
                          pendingQtyData?.width +
                          " " +
                          lengthUnit[
                            pendingQtyData?.units?.width
                          ]?.displayName?.toUpperCase()
                        : pendingQtyData?.width +
                          " " +
                          lengthUnit[
                            pendingQtyData?.units?.width
                          ]?.displayName?.toUpperCase()}
                    </p>
                    <p>
                      Order Quantity :{" "}
                      {pendingQtyData.quantity_type == "reel_sheet"
                        ? pendingQtyData.no_of_reel_sheet +
                          " " +
                          pendingQtyData.type +
                          "s"
                        : pendingQtyData.weight?.toFixed(3) +
                          " " +
                          capitalize(
                            weightUnit[pendingQtyData?.units?.weight]
                              ?.displayName
                          )}{" "}
                    </p>
                  </div>
                </div>

                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Pending Quantity</h5>
                    <p>
                      Details of the quantity pending to be planned in deckle
                    </p>
                    <>
                      <div className="subTitleWithText">
                        <p></p>
                      </div>
                      <div style={{ position: "relative" }}>
                        <Row className="centerAlign justifyCSBetween">
                          <Col span={13}>
                            <div className="boxFormType">
                              <Form.Item
                                name="pending_quantity"
                                initialValue={
                                  pendingQtyData.type == "reel" &&
                                  pendingQtyData.quantity_type == "reel_sheet"
                                    ? pendingQtyData.total_pending_quantity
                                    : parseFloat(
                                        pendingQtyData?.total_pending_quantity_weight
                                      )?.toFixed(3)
                                }
                                className=""
                              >
                                <Input disabled={true} />
                              </Form.Item>
                            </div>
                          </Col>
                          {pendingQtyData?.type == "reel" &&
                          pendingQtyData?.quantity_type == "reel_sheet" ? (
                            <Col span={10}>
                              <div className="boxFormType ">
                                <Form.Item
                                  name="reelUnit"
                                  initialValue={"reels"}
                                  className="dBlock"
                                >
                                  <Select
                                    suffixIcon={<DownArrowDraw />}
                                    disabled={true}
                                  ></Select>
                                </Form.Item>
                              </div>
                            </Col>
                          ) : (
                            <Col span={10}>
                              <div className="boxFormType ">
                                <Form.Item
                                  name="pending_quantity_unit"
                                  initialValue={capitalize(
                                    weightUnit[
                                      pendingQtyData?.units
                                        ?.total_pending_quantity_weight
                                    ]?.displayName
                                  )}
                                  className="dBlock"
                                >
                                  <Select
                                    suffixIcon={<DownArrowDraw />}
                                    disabled={true}
                                  ></Select>
                                </Form.Item>
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row className="centerAlign justifyCSBetween">
                          {pendingQtyData?.type == "reel" &&
                            pendingQtyData?.multiple_diameter_data?.map(
                              (item) => {
                                return (
                                  // <p>Reel OD: {""}{item.reel_od} {"  |  "} Core OD: {""}{item.core_id} {""}{""}{""}
                                  // <span style={{marginLeft: "20px"}}>Quantity: {""}{(pendingQtyData.total_pending_quantity_weight)?.toFixed(3)}{""}{capitalize(weightUnit[pendingQtyData?.units?.total_pending_quantity_weight]?.displayName)}
                                  // {"  |  "} {item?.total_pending_quantity}{" reels"}</span></p>
                                  <div className="titleWithText">
                                    <p style={{ marginBottom: "0px" }}>
                                      Reel OD: {""}
                                      {item.reel_od} {"  |  "} Core OD: {""}
                                      {item.core_id}
                                    </p>{" "}
                                    <p style={{ marginBottom: "2px" }}>
                                      Quantity: {""}
                                      {pendingQtyData.total_pending_quantity_weight?.toFixed(
                                        3
                                      )}{" "}
                                      {capitalize(
                                        weightUnit[
                                          pendingQtyData?.units
                                            ?.total_pending_quantity_weight
                                        ]?.displayName
                                      )}
                                      {"  |  "} {item?.total_pending_quantity}
                                      {" reels"}
                                    </p>
                                  </div>
                                );
                              }
                            )}
                          {pendingQtyData?.type == "sheet" && (
                            <>
                              <div className="titleWithText">
                                <p style={{ marginBottom: "0px" }}>
                                  Intermediate Reels: {""}
                                  {pendingQtyData?.total_pending_intermediate_reels?.[
                                    "weight"
                                  ]?.toFixed(3)}{" "}
                                  {capitalize(
                                    weightUnit[
                                      pendingQtyData?.units
                                        ?.total_pending_quantity_weight
                                    ]?.displayName
                                  )}{" "}
                                  {"  |  "}
                                  {
                                    pendingQtyData
                                      ?.total_pending_intermediate_reels?.[
                                      "quantity"
                                    ]
                                  }
                                  {" Sheets"}
                                </p>{" "}
                                <p style={{ marginBottom: "2px" }}>
                                  Sheets: {""}
                                  {pendingQtyData?.total_pending_sheets?.weight?.toFixed(
                                    3
                                  )}{" "}
                                  {capitalize(
                                    weightUnit[
                                      pendingQtyData?.units
                                        ?.total_pending_quantity_weight
                                    ]?.displayName
                                  )}{" "}
                                  {"  |  "}
                                  {
                                    pendingQtyData?.total_pending_sheets
                                      ?.quantity
                                  }
                                  {" Sheets"}
                                </p>
                              </div>
                              {/* <p>Intermediate Reels: {""}{(pendingQtyData?.total_pending_intermediate_reels?.["weight"])?.toFixed(3)}{" "}{capitalize(weightUnit[pendingQtyData?.units?.total_pending_quantity_weight]?.displayName)} {"  |  "} 
                                        {pendingQtyData?.total_pending_intermediate_reels?.["quantity"]}{" Sheets"}
                                        </p>
                                        <p>Sheets: {""}{(pendingQtyData?.total_pending_sheets?.weight)?.toFixed(3)}{" "}{capitalize(weightUnit[pendingQtyData?.units?.total_pending_quantity_weight]?.displayName)} {"  |  "} 
                                        {pendingQtyData?.total_pending_sheets?.quantity}{" Sheets"}
                                        </p>*/}
                            </>
                          )}
                        </Row>
                      </div>
                    </>
                  </div>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : null;
};
export default ViewPendingQuantityDrawer;
